import { thumbnailSizeMap } from "../shared/Data/consts";
import { fetchPost, appUrl } from "./networkRequests";
import { isBeta } from "./network";

const DBX_ROOT = 'dropbox'
const prot = process.env.REACT_APP_PROTOCOL

const basicRequest = async (args, endPoint, userToken)=>{
  const root_url = await appUrl()
  let body = new FormData()
  for (let key of Object.keys(args)) body.append(key, args[key])
  const full_url = `${prot}:${root_url}/${DBX_ROOT}/${endPoint}`
  let res = await fetchPost(body, full_url, userToken).then(res=>res.json())
  return res
}



const getDropboxFile = async (path, userToken)=>{
  // const root_url = await appUrl()
  // let body = new FormData()
  // body.append('path', path)
  // const full_url = `${prot}:${root_url}/${DBX_ROOT}/getDropboxFile`
  // console.log("getting dropbox file", full_url, path)
  // let res = await fetchPost(body, full_url, userToken).then(res=>res.json())
  // return res
  return await basicRequest({path}, 'getDropboxFile', userToken)
}

const downloadDropboxFileToLocation = async (path, localPath, userToken)=>{
  
  let dbxFile = await getDropboxFile(path, userToken)
  console.log('got res from getDropboxFile', dbxFile)
  // let buff = await blobToBuffer(dbxFile.fileBlob)
  let buff = dbxFile.fileBinary.data
  let url = URL.createObjectURL(buff)
  const a = document.createElement('a')
  a.href = url
  a.download = 'report_image.jpg'
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
  return
  // return writeFile(localPath, buff)
}

const uploadDropboxFileOverwrite = async (imageBlob, path, userToken)=>{
  const root_url = await appUrl()
  let body = new FormData()
  body.append('image', imageBlob, {
    contentType: 'image/jpeg',
  })
  body.append('path', path)
  const full_url = `${prot}:${root_url}/${DBX_ROOT}/uploadDropboxFileOverwrite`
  let res = await fetchPost(body, full_url, userToken).then(res=>res.json())
  return res
}

const uploadDropboxFile = async (imageBlob, path, userToken)=>{
  const root_url = await appUrl()
  let body = new FormData()
  body.append('image', imageBlob, {
    contentType: 'image/jpeg',
  })
  body.append('path', path)
  const full_url = `${prot}:${root_url}/${DBX_ROOT}/uploadDropboxFile`
  let res = await fetchPost(body, full_url, userToken).then(res=>res.json())
  return res
}

const checkDropboxPath = async (path, userToken)=>{
  // const root_url = await appUrl()
  // let body = new FormData()
  // body.append('path', path)
  // const full_url = `${prot}:${root_url}/${DBX_ROOT}/checkDropboxPath`
  // let res = await fetchPost(body, full_url, userToken).then(res=>res.json())
  // return res
  return basicRequest({path}, 'checkDropboxPath', userToken)
}

const deleteDropboxFile = async (path, userToken)=>{
  // const root_url = await appUrl()
  // let body = new FormData()
  // body.append('path', path)
  // const full_url = `${prot}:${root_url}/${DBX_ROOT}/deleteDropboxFile`
  // let res = await fetchPost(body, full_url, userToken).then(res=>res.json())
  // return res
  return basicRequest({path}, 'deleteDropboxFile', userToken)
}

export {
  // filesGetThumbnailBatch, 
  downloadDropboxFileToLocation,
  uploadDropboxFileOverwrite,
  checkDropboxPath,
  deleteDropboxFile,
  uploadDropboxFile
}
